import {useEffect, useRef, useState} from 'react';
import {Dialog} from './StudioShared.jsx';
import {FINGERS} from './design-model.js';
import './customer-preferences.css';

function editableSizes(profile) {
  const sizing = profile?.sizing;
  return {size:'custom', sizeMode:sizing?.sizeMode === 'preset' ? 'per-finger' : sizing?.sizeMode || 'per-finger',
    fingerSizes:sizing?.sizeMode === 'preset' ? Array(10).fill(sizing.size) : sizing?.fingerSizes || Array(10).fill(null),
    widths:sizing?.widths || Array(10).fill(null), tipNumbers:sizing?.tipNumbers || Array(10).fill(null)};
}

// The guide and both studio entry points edit the same saved record.
export function SizeProfileForm({profile, onChange, onForget, disabled = false}) {
  const [draft, setDraft] = useState(() => editableSizes(profile));
  const [error, setError] = useState('');
  const ownWrite = useRef(null);
  useEffect(() => {if(profile && profile === ownWrite.current)return;setDraft(editableSizes(profile)); setError('');}, [profile]);
  const mode = draft.sizeMode;
  const field = mode === 'per-finger' ? 'fingerSizes' : mode === 'millimeter' ? 'widths' : 'tipNumbers';
  const values = draft[field];
  function persist(next) {
    setDraft(next); setError('');
    try {ownWrite.current = onChange({...next, widths:next.widths.map(value => value === null || value === '' ? null : Number(value))});} catch {setError('尺寸保存失败，请检查浏览器存储后重试');}
  }
  function update(index, raw) {
    const value = raw === '' ? null : mode === 'tip-number' ? Number(raw) : raw;
    const next = {...draft, [field]:values.map((item, i) => i === index ? value : item)};
    // Keep an unfinished numeric keystroke visible without saving an invalid width.
    if (mode === 'millimeter' && value !== null && (!Number.isFinite(Number(value)) || Number(value) < 6 || Number(value) > 25)) {
      setDraft(next); setError('请填写全部十指的毫米尺寸，每指为 6–25 mm。'); return;
    }
    persist(next);
  }
  return <div className="size-profile">
    <fieldset className="size-profile-fields" disabled={disabled}>
      <div className="size-profile-modes" role="group" aria-label="尺寸记录方式">{[['per-finger','XS / S / M / L'],['millimeter','毫米尺寸'],['tip-number','甲片号']].map(([value,label]) => <button type="button" key={value} aria-pressed={mode === value} onClick={() => persist({...editableSizes(profile), sizeMode:value})}>{label}</button>)}</div>
      {[0,1].map(hand => <fieldset key={hand}><legend>{hand ? '右手' : '左手'}</legend><div className="size-profile-hand">{FINGERS.map((finger,i) => {
        const index = hand * 5 + i;
        return <label key={index}><span>{finger}</span>{mode === 'millimeter'
          ? <input aria-label={`${hand ? '右手' : '左手'}${finger}毫米宽度`} type="number" min="6" max="25" step="0.1" inputMode="decimal" value={values[index] ?? ''} onChange={e => update(index,e.target.value)}/>
          : <select aria-label={`${hand ? '右手' : '左手'}${finger}尺码`} value={values[index] ?? ''} onChange={e => update(index,e.target.value)}><option value="">—</option>{(mode === 'per-finger' ? ['XS','S','M','L'] : Array.from({length:10},(_,n) => n)).map(size => <option key={size} value={size}>{size}</option>)}</select>}</label>;
      })}</div></fieldset>)}
    </fieldset>
    <p className="size-profile-status" role="status">{error ? '' : profile ? '已自动保存并同步' : '填写后自动保存并同步'}</p>
    <p className="size-profile-note">尺寸指南、设计室和美甲室共用此记录，当前设计与新设计自动使用。仅保存在此浏览器，更换甲型后请核对。</p>
    {error ? <p role="alert">{error}</p> : null}
    {profile && <div className="size-profile-actions"><button type="button" disabled={disabled} onClick={() => {try {onForget();} catch {setError('尺寸保存失败，请检查浏览器存储后重试');}}}>删除尺寸记录</button></div>}
  </div>;
}

export default function SizeProfileDialog({onClose, ...props}) {
  return <Dialog title="我的尺寸" onClose={onClose}><SizeProfileForm {...props}/></Dialog>;
}
